import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import machineryImage from "../Images/Image/view-heavy-machinery-used-construction-industry (1).jpg";
import machineryImage2 from "../Images/Image/Gemini_Generated_Image_o9i2r7o9i2r7o9i2.jpeg";
import machineryImage3 from "../Images/work/img10-197x300.png";

import machineryImage4 from "../Images/Image/view-heavy-machinery-used-construction-industry (2).jpg";

import { clients } from "../data/clientsData";
import { services } from "../data/services";
import "../css/LandingPage.css";

import "../App.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [machineryImage, machineryImage2, machineryImage4];
  const [hasAnimated, setHasAnimated] = useState(false);
  const metricsRef = useRef(null);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const animateNumbers = useCallback(() => {
    const metricsSection = metricsRef.current;
    if (!metricsSection) return;

    const rect = metricsSection.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (isVisible && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [hasAnimated]); // Wrapped animateNumbers in useCallback to fix dependency issue

  useEffect(() => {
    window.addEventListener("scroll", animateNumbers);
    return () => window.removeEventListener("scroll", animateNumbers);
  }, [animateNumbers]); // Added animateNumbers as a dependency

  const animateValue = (start, end, duration, setValue) => {
    let startTime = null;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const value = Math.floor(progress * (end - start) + start);
      setValue(value);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  const [customers, setCustomers] = useState(0);
  const [employees, setEmployees] = useState(0);
  const [projects, setProjects] = useState(0);
  const [machinery, setMachinery] = useState(0);

  useEffect(() => {
    if (hasAnimated) {
      animateValue(0, 500, 2000, setCustomers);
      animateValue(0, 50, 2000, setEmployees);
      animateValue(0, 50, 2000, setProjects);
      animateValue(0, 18, 2000, setMachinery);
    }
  }, [hasAnimated]);

  console.log("Right Content Data:", services.slice(3, 6));

  return (
    <div style={{ margin: 0, padding: 0 }}>
      {/* IMAGE HERO SLIDER */}
      <div style={{ position: "relative", height: "300px", overflow: "hidden", margin: 0 }}>
        <img
          src={images[currentSlide]}
          alt="Heavy Machinery Solutions"
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            filter: "brightness(0.5)",
            objectFit: "cover",
            transition: "opacity 0.5s ease-in-out",
          }}
        />
        <h1
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "48px",
            fontWeight: "bold",
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
            margin: 0,
            whiteSpace: "nowrap",
          }}
        >
          {currentSlide === 0
            ? "Strength in Building, Support in Equipment"
            : currentSlide === 1
            ? "Top-Quality Service At Unbeatable Prices!"
            : "Powering Your Projects with Precision, Performance & Prices You Can Trust!"}
        </h1>

        {/* Previous Button */}
        <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            left: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255, 107, 53, 0.8)",
            color: "white",
            border: "none",
            padding: "10px 15px",
            fontSize: "24px",
            cursor: "pointer",
            borderRadius: "5px",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255, 107, 53, 1)")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(255, 107, 53, 0.8)")}
        >
          ❮
        </button>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(255, 107, 53, 0.8)",
            color: "white",
            border: "none",
            padding: "10px 15px",
            fontSize: "24px",
            cursor: "pointer",
            borderRadius: "5px",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255, 107, 53, 1)")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "rgba(255, 107, 53, 0.8)")}
        >
          ❯
        </button>

        {/* Slide Indicators */}
        <div style={{ position: "absolute", bottom: "15px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "10px" }}>
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: currentSlide === index ? "#ff6b35" : "rgba(255, 255, 255, 0.5)",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
            />
          ))}
        </div>
      </div>

      {/* WHERE WE CAN ASSIST YOU SECTION */}
      <div
        style={{
          padding: "50px 20px",
          backgroundColor: "#f4f6f8",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "36px",
            fontWeight: "bold",
            color: "#0b2447",
            marginBottom: "10px",
          }}
        >
          Where We Can Assist You?
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#666",
            marginBottom: "40px",
            maxWidth: "600px",
            margin: "0 auto 40px",
          }}
        >
          From building works to equipment rentals, we deliver complete construction solutions.
        </p>

        {/* Service Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {/* Card 1 */}
          <div
            onClick={() => navigate("/rental")}
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              transition: "transform 0.3s, boxShadow 0.3s",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
            }}
          >
            <div>
              <h3 style={{ fontSize: "24px", marginBottom: "10px" }}>🚜 Equipment Rental</h3>
              <p style={{ color: "#666" }}>Top-quality equipment available for short- and long-term projects.</p>
            </div>

          </div>

          {/* Card 2 */}
          <div
            onClick={() => navigate("/projects")}
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              transition: "transform 0.3s, boxShadow 0.3s",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
            }}
          >
            <h3 style={{ fontSize: "24px", marginBottom: "10px" }}>🏗️ Our Projects </h3>
            <p style={{ color: "#666" }}>Explore the projects we’re currently building and those we’ve proudly completed.</p>
          </div>

          {/* Card 3 */}
          <div
            onClick={() => navigate("/contact")}
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              transition: "transform 0.3s, boxShadow 0.3s",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
            }}
          >
            <div>
              <h3 style={{ fontSize: "24px", marginBottom: "10px" }}>💡 Consultation</h3>
              <p style={{ color: "#666" }}>Professional advice and equipment recommendations</p>
            </div>
          </div>
        </div>
      </div>

      {/* CLIENTS SECTION */}
      <div style={{ backgroundColor: "#f8f8f8", padding: "80px 40px"}}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* Section Header */}
          <div style={{ textAlign: "center", marginBottom: "70px" }}>
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
              backgroundColor: "rgba(255, 107, 53, 0.1)",
              padding: "10px 20px",
              borderRadius: "30px",
              border: "1px solid rgba(255, 107, 53, 0.3)",
            }}>
              <span style={{ width: "8px", height: "8px", backgroundColor: "#ff6b35", borderRadius: "50%" }}></span>
              <span style={{ color: "#ff6b35", fontWeight: "700", fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase" }}>
                Our Trusted Partner's
              </span>
            </div>

            <h2 style={{
              fontSize: "48px",
              fontWeight: "900",
              marginBottom: "20px",
              color: "#0b2447",
              letterSpacing: "-1px",
            }}>
              Our Clients
            </h2>

            <p style={{
              fontSize: "16px",
              color: "#666",
              maxWidth: "600px",
              margin: "0 auto",
              lineHeight: "1.8",
              fontWeight: "500",
            }}>
              Trusted by leading organizations across government and private sectors
            </p>
          </div>

          {/* Clients Grid */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "40px",
            alignItems: "center",
            justifyItems: "center",
          }}>
            {clients.map((client, index) => (
              <div
                key={index}
                style={{
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px) scale(1.08)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                }}
              >
                {/* Client Logo/Image */}
                <div style={{
                  width: "150px",
                  height: "150px",
                  margin: "0 auto 20px",
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "white",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "box-shadow 0.3s ease",
                  border: "2px solid rgba(255, 107, 53, 0.1)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 12px 30px rgba(255, 107, 53, 0.2)";
                  e.currentTarget.style.borderColor = "rgba(255, 107, 53, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
                  e.currentTarget.style.borderColor = "rgba(255, 107, 53, 0.1)";
                }}
                >
                  <img
                    src={client.image}
                    alt={client.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      padding: "20px",
                    }}
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/150x150?text=" + encodeURIComponent(client.name);
                    }}
                  />
                </div>

                {/* Client Name */}
                <h3 style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#0b2447",
                  marginBottom: "8px",
                  margin: "0 0 8px 0",
                }}>
                  {client.name}
                </h3>

                {/* Client Category */}
                <span style={{
                  display: "inline-block",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#ff6b35",
                  backgroundColor: "rgba(255, 107, 53, 0.1)",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}>
                  {client.category}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* METRICS DASHBOARD */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px 20px",
          textAlign: "center",
          borderTop: "1px solid #ddd",
          borderBottom: "1px solid #ddd",
          maxWidth: "1000px",
          margin: "40px auto",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        ref={metricsRef}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", color: "#ff6b35" }}>👥</div>
            <h3 style={{ fontSize: "28px", color: "#ff6b35", marginBottom: "10px" }}>Happy Customers</h3>
            <p style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>{customers}+</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", color: "#ff6b35" }}>👷</div>
            <h3 style={{ fontSize: "28px", color: "#ff6b35", marginBottom: "10px" }}>Skilled Employees</h3>
            <p style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>{employees}+</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", color: "#ff6b35" }}>🏗️</div>
            <h3 style={{ fontSize: "28px", color: "#ff6b35", marginBottom: "10px" }}>Projects Done</h3>
            <p style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>{projects}+</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", color: "#ff6b35" }}>🚜</div>
            <h3 style={{ fontSize: "28px", color: "#ff6b35", marginBottom: "10px" }}>Machinery</h3>
            <p style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>{machinery}+</p>
          </div>
        </div>
      </div>

      {/* SERVICES SECTION */}
     <section className="services-section">
  <div className="services-wrapper">

    {/* Left Content */}
    <div className="services-box">
      {services.slice(0, 3).map((service, index) => (
        <div key={index} className="service-item">
          <h3>
            {service.number} {service.title}
          </h3>
          <p>{service.description}</p>
        </div>
      ))}
    </div>

    {/* Middle Image */}
    <div className="services-image">
      <img src={machineryImage3} alt="Service" />
    </div>

    {/* Right Content */}
    <div className="services-box">
      {services.slice(3, 6).map((service, index) => (
        <div key={index} className="service-item">
          <h3>
            {service.number} {service.title}
          </h3>
          <p>{service.description}</p>
        </div>
      ))}
    </div>

  </div>
</section>
    </div>
  );
};

export default LandingPage;
